exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge {\n  position: relative;\n  width: 100%;\n  padding-top: 100%;\n  border-radius: 10%;\n}\n\n.badge img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  mix-blend-mode: screen;\n  filter: grayscale(100%) contrast(100%);\n  opacity: 1;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/shared/badges/components/badge-component/badge.component.css
// module id = ../../../../../src/app/shared/badges/components/badge-component/badge.component.css
// module chunks = main